import React, { useState } from 'react'

import Button from 'components_new/atoms/Button'
import Icon, { IconName } from 'components_new/atoms/Icon'
import Link from 'components_new/atoms/Link'
import List from 'components_new/atoms/List'
import ListItem from 'components_new/atoms/List/ListItem'
import ListItemIcon from 'components_new/atoms/List/ListItemIcon'
import ListItemText from 'components_new/atoms/List/ListItemText'
import Text from 'components_new/atoms/Text'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'
import SimpleDialog from 'components_new/molecules/SimpleDialog'
import { useTranslation } from 'language/translator'

export interface NoValueProps {
  embedded?: boolean
  iconName: IconName
  scaleFactor: number
}

const NoValue = (props: NoValueProps) => {
  const { embedded, iconName, scaleFactor } = props

  const { t } = useTranslation()

  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <EmptyPlaceholder
        actions={
          !embedded ? (
            <Link onClick={() => setDialogOpen(true)}>
              {t('global', 'more_information')}
            </Link>
          ) : undefined
        }
        background={true}
        title={t('widgets', 'no_data_title')}
        icon={iconName}
        scaleFactor={scaleFactor}
      />

      <SimpleDialog
        onClose={() => setDialogOpen(false)}
        open={dialogOpen}
        title={t('global', 'more_information')}
        actions={
          <Button onClick={() => setDialogOpen(false)} variant="text">
            {t('global', 'close')}
          </Button>
        }
      >
        <EmptyPlaceholder
          background={true}
          title={t('widgets', 'no_data_title')}
          icon={iconName}
          sx={{ mb: 4 }}
        />
        <Text variant="subtitle2" gutterBottom>
          {t('widgets', 'no_data_subtitle')}
        </Text>
        <Text color="text.secondary" sx={{ mt: 2 }}>
          {t('widgets', 'no_data_description')}
        </Text>
        <List>
          <ListItem>
            <ListItemIcon>
              <Icon name="HelpOutline" />
            </ListItemIcon>
            <ListItemText>
              {t('widgets', 'no_data_reason_time_period')}
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Icon name="HelpOutline" />
            </ListItemIcon>
            <ListItemText>
              {t('widgets', 'no_data_reason_metric_filter')}
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Icon name="HelpOutline" />
            </ListItemIcon>
            <ListItemText>
              {t('widgets', 'no_data_reason_dashboard_filter')}
            </ListItemText>
          </ListItem>
        </List>
      </SimpleDialog>
    </>
  )
}

export default NoValue
